<template>
  <div class="profile__wrapper categorisation__hotel">
    <div class="categorisation__hotel-search">
      <h5 class="title-h5 profile__subtitle">Оберіть готель</h5>
      <div class="categorisation__hotel-search-alert" v-html="$t('categorization.hotel_select_desc', {url: hotelsSignUrl})"></div>
      <div class="categorisation__hotel-search-form">
        <SelectField
        v-model="hotel"
        :items="[]"
        :title="'Пошук по назві або ЄДРПОУ'"
        :inputId="`hotels_input`"
        class="statistic-type__filter-select"
        @search-input="onHotelsSearch"
        :search-callback="hotelsSearchHandler"
        titleKey="title"
        value="uuid"
        isObjectType
        valueToReturn="object"
        :isInactive="!isCreateRoute"
      />
      </div>
    </div>
    <template v-if="hotel && !isCategorisationCreate">
      <div class="categorisation categorisation__wrapper" v-if="structure">
        <div
          class="profile__section"
          :style="{ order: group.order_position }"
          v-for="(group, id_0) in structure"
          :key="`${group.uuid}${id_0}`"
        >
          <h4 class="title-h4 profile__title" v-if="!!group.title">
            {{ group.title }}
          </h4>
          <div
            class="categorisation__block"
            :style="{ order: subgroup.order_position }"
            v-for="(subgroup, id_1) in group.subgroups"
            :key="`${subgroup.uuid}${id_1}`"
          >
            <h5 class="title-h5 profile__subtitle" v-if="!!subgroup.title">
              {{ subgroup.title }}:
            </h5>
            <div
              :class="[
                subgroup.criterias[0].type === 'images'
                  ? 'image__grid'
                  : 'profile__grid',
              ]"
            >
              <div
                v-for="(item, id_2) in subgroup.criterias"
                :key="`${item.uuid}${id_2}`"
                :class="`${item.classnames}`"
                :style="{ order: item.order_position }"
                :id="item.uuid"
              >
                <text-field
                  v-if="['text', 'number', 'rating'].includes(item.type)"
                  v-model="item.value"
                  :is-error="
                    $v.structureData.$each[id_0].subgroups.$each[id_1].criterias
                      .$each[id_2].$error
                  "
                  :stars-read-only="editIsDisabled(item.uuid) || !isEditable"
                  :error-text="$t(`error.required_field`)"
                  :title="item.title"
                  :is-rate="item.type === 'rating'"
                  :is-icon="item.type === 'text_icon'"
                  :value-mask="item.mask"
                  :is-required="item.validation.includes('required')"
                  :is-integer="item.validation.includes('int')"
                  :is-inactive="editIsDisabled(item.uuid) || !isEditable"
                  icon-name="actual"
                  :can-comment="canComment"
                  :is-commentable="commentsVisible"
                  :is-last-comment-visible="true"
                  :uuid="item.uuid"
                  :id="item.uuid"
                />
                <FileUpload
                  v-else-if="['file', 'files'].includes(item.type)"
                  :id="item.uuid"
                  v-model="item.value"
                  :is-error="
                    $v.structureData.$each[id_0].subgroups.$each[id_1].criterias
                      .$each[id_2].$error
                  "
                  :error-text="$t(`error.required_field`)"
                  :title="item.title"
                  :is-multiple="item.type == 'files'"
                  :valid-formats="fileTypes(item.validation)"
                  :max-size-k-b="fileSizeLimit(item.validation)"
                  :is-download-only="!editIsDisabled(item.uuid) && !isEditable"
                  :can-comment="canComment"
                  :is-commentable="commentsVisible"
                  :is-inactive="editIsDisabled(item.uuid) || !isEditable"
                  :uuid="item.uuid"
                  @uploadFiles="uploadFiles($event, item)"
                  @dropError="item.error = false"
                />
                <PhotoUpload
                  v-else-if="['images'].includes(item.type)"
                  :id="item.uuid"
                  :uuid="item.uuid"
                  v-model="item.value"
                  :is-error="
                    $v.structureData.$each[id_0].subgroups.$each[id_1].criterias
                      .$each[id_2].$error
                  "
                  :error-text="$t(`error.required_field`)"
                  :photos-uploaded="item.value"
                  :title="item.title"
                  is-multiple
                  :valid-formats="fileTypes(item.validation)"
                  :can-comment="canComment"
                  :is-commentable="commentsVisible"
                  :is-disabled="editIsDisabled(item.uuid) || !isEditable"
                  :is-inactive="editIsDisabled(item.uuid) || !isEditable"
                  :max-size-k-b="fileSizeLimit(item.validation)"
                  @uploadFiles="uploadFiles($event, item)"
                />
                <div
                  :class="`${item.classnames}`"
                  v-else-if="item.type === 'switcher'"
                >
                  <Switcher
                    :uuid="item.uuid"
                    :can-comment="canComment"
                    :is-commentable="commentsVisible"
                    :is-inactive="editIsDisabled(item.uuid) || !isEditable"
                    v-model="item.value"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-else>
        <LoaderContent />
      </template>
    </template>
    <div class="no-print" v-if="hotel">
      <ButtonsBlock
        :buttons="buttonsArray"
        :disabledDownLoad="!isCertificate"
        :disabledAchive="!isAchive"
        @print="print()"
        @createReport="createDraft"
        @createAndSignReport="createAndSignReport"
        @saveAsDraft="editDraft"
        @signAndSend="signAndSendReport"
        @downloadPDF="downloadPDF()"
        @downloadCertificate="downloadCertificate()"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { requiredIf } from 'vuelidate/lib/validators';
import { getCategorizationFormStructure, searchHotels } from '@/api/services/certification_agency.js';
import FileUpload from '@/elements/FileUpload.vue';
import PhotoUpload from '@/elements/PhotoUpload.vue';
import Switcher from '@/elements/Switcher.vue';
import ButtonsBlock from '@/elements/ButtonsBlock.vue';
import LoaderContent from '@/elements/LoaderContent.vue';
import SelectField from "@/elements/SelectField.vue";

export default {
  components: {
    FileUpload,
    PhotoUpload,
    Switcher,
    ButtonsBlock,
    LoaderContent,
    SelectField,
  },

  data() {
    return {
      buttonsArray: [],
      commentsVisible: false,
      canComment: '',
      canEdit: '',
      voteSchedule: '',
      dataToSend: null,
      validationPassed: true,

      idx: 0,
      structure: null,
      isSaved: false,
      hotel: null,
      hotelsSearchQuery: '',
    };
  },

  async created() {
    await this.getCategorizationStructure();

    this.$store.commit('SET_CURRENT_FORM_TYPE', 'categorization-hotel'); // for key-sign flow

    let categorizationRequestUUUID = this.$route.params.id;

    if (this.$route.params.activity !== 'create' && !!this.$route.params.id) {
      let categorizationRequestUUUID = this.$route.params.id;
      await this.$store.dispatch(
        'getCategorizationHotelCA',
        categorizationRequestUUUID
      );

      this.hotel = this.getCategorizationHotelCA?.hotel

      this.populateFormWithData();
    } else {
    }
    await this.statusModelHandler();

    if (this.commentsVisible) {
      await this.$store.dispatch(
        'getCommentsHotelCA',
        categorizationRequestUUUID
      );
    }
  },

  beforeDestroy() {
    this.$store.dispatch('clearStore'); // call mutation
  },

  watch: {
    isCategorisationCreate(val) {
      val && this.$router.push({ name: 'certificate_agency_hotel_categorizations-list' });
      this.$store.commit('SET_CATEGORISATION_DRAFT_SAVED', false);
    },

    structure: {
      handler(arr) {
        arr.map((g, i) =>
          g.subgroups.map((s) =>
            s.criterias.map((c) => {
              if (!!c.sum_of.length) {
                let sum = 0;
                c.sum_of.map((k) => {
                  sum += !!this.fieldsObjForCalculate[k]
                    ? this.fieldsObjForCalculate[k]
                    : 0;
                });
                c.value = `${sum}`;
              }
            })
          )
        );
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters('modal', ['getModalState']),
    ...mapGetters([
      'getCategorizationHotelCA',
      'getCommentsHotelCA',
      'getStatusModel',
      'isCategorizationDraftSaved',
      'isUserHasEuKey',
    ]),

    hotelsSignUrl() {
      return `${window.location.origin}/hotels/sign-in`
    },

    isCreateRoute() {
      return this.$route.name === 'certification_agency_hotel_categorization-create' ? true : false;
    },

    isCategorisationCreate() {
      return !this.getModalState && this.isCategorizationDraftSaved;
    },

    structureData() {
      return this.structure;
    },

    isEditable() {
      return !!Object.keys(this.$route.params).length
        ? this.$route.params.activity === 'edit' ||
            this.$route.params.activity === 'create'
        : true;
    },

    fieldsObjForCalculate() {
      let obj = {};

      this.structure?.map((g) =>
        g.subgroups.map((s) =>
          s.criterias.map((c) => {
            if (c.validation.includes('int')) {
              if (Number.isInteger(c.value)) {
                obj[c.uuid] = c.value;
              } else {
                obj[c.uuid] = !!c.value
                  ? parseInt(c.value.split(' ').join(''))
                  : 0;
              }
            }
          })
        )
      );

      return obj;
    },

    errorFieldId() {
      let res;
      this.structure.find((el) =>
        el.subgroups.find((s) =>
          s.criterias.find((c) => {
            if (
              c.validation.includes('required') &&
              (c.value === null || !Boolean(c.value.length)) &&
              c.type !== 'switcher'
            ) {
              return (res = c.uuid);
            }
          })
        )
      );

      return res;
    },

    prefilledCriteris() {
      if (this.$route.meta.status != 'create') {
        let prefilledCriteris = {};
        this.getCategorizationHotelCA?.criteria?.forEach((criteria) => {
          prefilledCriteris[criteria.categorization_criterion_uuid] = criteria;
        });
        return prefilledCriteris;
      } else return {};
    },

    prefilledCriterisUUID() {
      if (this.$route.meta.status != 'create') {
        return Object.keys(this.prefilledCriteris);
      } else return {};
    },

    preLoadedFiles() {
      if (this.$route.meta.status != 'create') {
        let preLoadedFiles = {};
        this.getCategorizationHotelCA.criteria.forEach((criteria) => {
          if (Array.isArray(criteria.value)) {
            this.$set(
              preLoadedFiles,
              criteria.categorization_criterion_uuid,
              criteria.value
            );
          }
        });
        return preLoadedFiles;
      } else return {};
    },

    preLoadedFilesUUID() {
      if (this.$route.meta.status != 'create') {
        return Object.keys(this.preLoadedFiles);
      } else return {};
    },

    isCertificate() {
      return !!this.getCategorizationHotelCA?.certificate;
    },

    isAchive() {
      return !!this.getCategorizationHotelCA?.archive;
    },
  },

  destroyed() {
    clearInterval(this.timeout)
  },

  methods: {
    onHotelsSearch(e) {
      this.hotelsSearchQuery = e
    },
    async hotelsSearchHandler(vm) {
      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(async () => {
        if(this.hotelsSearchQuery.length < 3) return;

        const response = await searchHotels(this.hotelsSearchQuery);

        const arr = response.data.data.hotels;
        vm.items.splice(0, vm.items.length);
        vm.items.push(...arr);

        vm.filteredContent = vm.items;

        if (!!this.hotelsSearchQuery && !vm.isMultiSelect) {
          vm.filteredContent = vm.items;
        }
      }, 500);
    },

    async getCategorizationStructure() {
      let data = { lang: 'uk' };
      if (this.$route.params.activity !== 'create' && !!this.$route.params.id) {
        data.uuid = this.$route.params.id;
      }
      try {
        let res;
        res = await getCategorizationFormStructure(data);
        if (res.status === 200) {
          this.structure = res.data.data.structure;

        }
      } catch (e) {
        console.log(
          '>>> error getCategorizationFormStructure',
          e.response.data.error
        );
      }
    },

    statusModelHandler() {
      console.log(this.getStatusModel)

      this.getStatusModel.forEach((element) => {
        console.log(element.filing_status)
        if (
          element.filing_status == this.getCategorizationHotelCA.filing_status &&
          element.review_status == this.getCategorizationHotelCA.review_status
        ) {
          this.commentsVisible = element.comments_visible;
          this.buttonsArray = element.buttons;
          console.log(this.buttonsArray)
          this.canComment = element.can_comment;
          this.canEdit = element.edit;
          this.voteSchedule = element.schedule;
        }
      });
    },

    populateFormWithData() {
      this.structure.map((el) =>
        el.subgroups.map((s) =>
          s.criterias.map(async (s) => {
            if (s.uuid in this.prefilledCriteris) {
              if (Array.isArray(this.prefilledCriteris[s.uuid].value)) {
                let valueToPopulate = [];

                for (let file in this.prefilledCriteris[s.uuid].value) {
                  let convertedFile = await this.createFile(
                    this.prefilledCriteris[s.uuid].value[file].original_url,
                    this.prefilledCriteris[s.uuid].value[file].mime
                  );
                  valueToPopulate.push(convertedFile);
                }
                s.value = valueToPopulate;
              } else {
                s.value = this.prefilledCriteris[s.uuid].value;
              }
            }
          })
        )
      );
    },

    async createFile(url, type) {
      const response = await fetch(url);
      const data = await response.blob();
      const metadata = {
        type: type,
      };
      return new File([data], url.split('/').at(-1), metadata);
    },

    editIsDisabled(uuid) {
      let editIsDisabled = false;
      switch (this.canEdit) {
        case 'can_edit_all_fields':
          editIsDisabled = false;
          break;
        case 'not_allowed':
          editIsDisabled = true;
          break;
        case 'can_edit_commented_fields':
          this.getCommentsHotelCA[uuid]
            ? (editIsDisabled = false)
            : (editIsDisabled = true);
          break;
      }
      return editIsDisabled;
    },

    fileTypes(fileValidation) {
      let fileTypes = [];
      fileValidation.forEach((element) => {
        if (element.includes('mimes')) {
          fileTypes = element.split(':')[1].split(',');
        }
      });
      return fileTypes;
    },

    fileSizeLimit(fileValidation) {
      let fileSizeLimit = [];
      fileValidation.forEach((element) => {
        if (element.includes('max')) {
          fileSizeLimit = parseInt(element.split(':')[1]);
        }
      });
      return fileSizeLimit;
    },

    checkFilesIdentity(fileOne, fileTwo) {
      if (
        fileOne.size == fileTwo.size &&
        fileOne.original_url.split('/').at(-1) == fileTwo.name
      ) {
        return true;
      }
    },

    addToDataToSend(uuid, value) {
      this.dataToSend.append(`criterias[${this.idx}][uuid]`, uuid);
      this.dataToSend.append(`criterias[${this.idx}][value]`, value);
      this.idx += 1;
    },

    addFileToSend(uuid, value) {
      this.dataToSend.append(`criterias[${this.idx}][uuid]`, uuid);
      this.dataToSend.append(`criterias[${this.idx}][value]`, value);
      this.idx += 1;
    },

    addMultipleFilesToSend(uuid, values) {
      this.dataToSend.append(`criterias[${this.idx}][uuid]`, uuid);
      for (let i = 0; i < values.length; i++) {
        this.dataToSend.append(
          `criterias[${this.idx}][value][][attachment]`,
          values[i]
        );
      }
      this.idx += 1;
    },

    addDeleteCriteria(uuid) {
      this.dataToSend.append(`delete_criterias[]`, uuid);
    },

    addDeleteCriteriaAttachment(uuid) {
      this.dataToSend.append(`delete_attachments[]`, uuid);
    },

    createDraft() {
      this.gatherAllCriteriasCreate();
      this.$store.dispatch('addCategorizationRequestDraftCA', this.dataToSend);
    },

    async createAndSignReport() {

      // this.$store.commit('modal/SET_MODAL', {
      //       state: true,
      //       name: 'add-key',
      //       size: 'l',
      //     });

      this.gatherAllCriteriasCreate();
      this.$v.$reset();
      this.$v.$touch();
      if (this.$v.$invalid) {
        document
          .getElementById(this.errorFieldId)
          .scrollIntoView({ block: 'start', behavior: 'smooth' });
      } else {
        this.$store.dispatch(
          'createFullCategorizationRequestCA',
          this.dataToSend
        );
      }
    },

    editDraft() {
      this.gatherAllCriteriasEdit();
      this.$store.dispatch('editCategorizationRequestCA', this.dataToSend);
    },

    signAndSendReport() {
      this.gatherAllCriteriasEdit();
      this.$v.$reset();
      this.$v.$touch();
      if (this.$v.$invalid) {
        document
          .getElementById(this.errorFieldId)
          .scrollIntoView({ block: 'start', behavior: 'smooth' });
      } else {
        // this.$store.commit(
        //   'SET_DATA_TO_SIGN',
        //   this.getCategorizationHotelCA.uuid
        // );
        this.$store.dispatch(
          'createFullCategorizationRequestCA',
          /*'signEditedCategorizationRequestCA',*/
          this.dataToSend
        );
      }
    },

    gatherAllCriteriasCreate() {

      this.dataToSend = new FormData();

      this.structure.map((el) =>
        el.subgroups.map((s) =>
          s.criterias.map((c) => {
            // Text and numbers
            if (['text', 'number', 'rating'].includes(c.type)) {
              if (c.value !== '' && c.value) {
                let val = c.value;
                if (
                  c.validation.includes('int') &&
                  !Number.isInteger(c.value)
                ) {
                  val = parseInt(c.value);
                }

                if (!!val) {
                  this.addToDataToSend(c.uuid, val);
                }
              }
            }
            // Single file
            if (c.type === 'file' && !!c.value.length) {
              this.addFileToSend(c.uuid, c.value[0]);
            }
            // Multiple files
            if (['files', 'images'].includes(c.type) && !!c.value.length) {
              this.addMultipleFilesToSend(c.uuid, c.value);
            }
            if (c.type == 'switcher') {
              this.addToDataToSend(c.uuid, c.value ? 1 : 0);
            }
          })
        )
      );

      this.dataToSend.append(`hotel_uuid`, this.hotel.uuid);
    },

    gatherAllCriteriasEdit() {
      this.dataToSend = new FormData();
      this.dataToSend.append(
        'categorization_application_uuid',
        this.getCategorizationHotelCA.uuid
      );
      this.dataToSend.append(`hotel_uuid`, this.hotel.uuid);

      this.structure.map((el) =>
        el.subgroups.map((s) =>
          s.criterias.map((c) => {
            // Text and numbers
            if (['text', 'number', 'rating'].includes(c.type)) {
              // Checking for prefilling
              if (this.prefilledCriterisUUID.includes(c.uuid)) {
                if (c.value === '') {
                  this.addDeleteCriteria(this.prefilledCriteris[c.uuid].uuid);
                } else {
                  let val = c.value;
                  if (
                    c.validation.includes('int') &&
                    !Number.isInteger(c.value)
                  ) {
                    val = parseInt(c.value);
                  }
                  this.addToDataToSend(c.uuid, val);
                }
              } else {
                if (!!c.value) {
                  let val =
                    c.validation.includes('int') && !Number.isInteger(c.value)
                      ? parseInt(c.value)
                      : c.value;

                  if (!!val) {
                    this.addToDataToSend(c.uuid, val);
                  }
                }
              }
            }
            // Single file
            if (c.type == 'file') {
              if (this.preLoadedFilesUUID.includes(c.uuid)) {
                if (!c.value[0]) {
                  this.addDeleteCriteriaAttachment(
                    this.preLoadedFiles[c.uuid][0].id
                  );
                } else {
                  let prefilledFileInSubmitted = false;
                  prefilledFileInSubmitted = this.checkFilesIdentity(
                    this.preLoadedFiles[c.uuid][0],
                    c.value[0]
                  );
                  if (!prefilledFileInSubmitted) {
                    this.addFileToSend(c.uuid, c.value[0]);
                  }
                }
              } else if (!!c.value?.length) {
                this.addFileToSend(c.uuid, c.value[0]);
              }
            }
            // Multiple files
            if (['files', 'images'].includes(c.type) && c.value) {
              if (this.preLoadedFilesUUID.includes(c.uuid)) {
                // Check for deletion
                this.preLoadedFiles[c.uuid].forEach((preloaded) => {
                  let prefilledFileInSubmitted = false;
                  c.value.forEach((submitting) => {
                    if (this.checkFilesIdentity(preloaded, submitting)) {
                      prefilledFileInSubmitted = true;
                      return;
                    }
                  });
                  if (!prefilledFileInSubmitted) {
                    this.addDeleteCriteriaAttachment(preloaded.id);
                  }
                });
                // Check for addition
                c.value.forEach((submitting) => {
                  let submittedFileInPreloaded = false;
                  this.preLoadedFiles[c.uuid].forEach((preloaded) => {
                    if (this.checkFilesIdentity(preloaded, submitting)) {
                      submittedFileInPreloaded = true;
                    }
                  });
                  if (!submittedFileInPreloaded) {
                    this.dataToSend.append(
                      `criterias[${this.idx}][uuid]`,
                      c.uuid
                    );
                    this.dataToSend.append(
                      `criterias[${this.idx}][value][][attachment]`,
                      submitting
                    );
                    this.idx++;
                    // this.addMultipleFilesToSend(c.uuid, submitting);
                  }
                });
              } else if (!!c.value?.length) {
                this.addMultipleFilesToSend(c.uuid, c.value);
              }
            }
            //switcher
            if (c.type == 'switcher') {
              this.addToDataToSend(c.uuid, c.value ? 1 : 0);
            }
          })
        )
      );
    },

    print() {
      window.print();
    },

    downloadCertificate() {
      this.$store.dispatch(
        'downloadFile',
        this.getCategorizationHotelCA.certificate.attachment.original_url
      );
    },

    downloadPDF() {
      this.$store.dispatch(
        'downloadFile',
        this.getCategorizationHotelCA.archive.original_url
      );
    },
  },

  validations() {
    return {
      structureData: {
        $each: {
          subgroups: {
            $each: {
              criterias: {
                $each: {
                  value: {
                    required: requiredIf((value) => {
                      let res = false;
                      if (value.type !== 'switcher') {
                        res = value.validation.includes('required');
                      }
                      return res;
                    }),
                  },
                },
              },
            },
          },
        },
      },
    };
  },
};
</script>

<style lang="sass" scoped>
.categorisation__wrapper, .profile__section
  display: flex
  flex-direction: column

.categorisation
  min-height: 20vh

.categorisation__hotel
  min-height: 500px

  &-search
    margin-bottom: 4rem

    .profile__subtitle
      margin-bottom: 2rem

    &-alert
      margin-bottom: 4rem
      max-width: 700px

    &-form
      max-width: 700px

</style>
